import styled from "styled-components";

export const WarningTextDefaultBox = styled.span`
    font-size: 1.2rem;
    width: calc(100% - 50px);
    display: inline-block;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
`;
